import React from 'react';

import { About, Footer, Header } from './container';
import { Navbar } from './components';
import './App.css';

const Home = () => (
  <div className="Home">
    <Navbar />
    <Header />
    <About />
    <Footer />
  </div>
);

export default Home;
